import * as React from 'react';
import { styled, ThemeProvider, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Bs4Tooltip from '../../Bs4Components/Bs4Tooltip';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import {getBs4Style} from '../../Bs4Components/Bs4Utils'

import Bs4Stores from '../../Bs4Stores'
import Bs4GenericField from './Bs4GenericField'
import Typography from '@mui/material/Typography';

export default class Bs4IconSelect extends Bs4GenericField {  

  setValueBs4(valueOrg) {
    let value = valueOrg;
    if (Array.isArray(value)) value = value[0];
    if (typeof value === 'undefined') value = null;
    if (!Array.isArray(this.bs4Store)) this.bs4Store = [];
    if (this.bs4CardMainForObject) {
      value = this.bs4Store.find(item => item.id == value) || null;
      if (!value) {
        value = this.bs4Store[0] || null;
      }
    } else {
      this.bs4Store = Bs4Stores.addUnknownValuesToStore(this.bs4Store, [value]);
      value = this.bs4Store.find(item => item.id == value) || null;
    }
    this.setValue(value);
  }

  getValueBs4 () {    
    return this.value?.id || '';
  }

  isDifferentValues (oldValue, newVaue) {
    return oldValue?.id != newVaue?.id;
  }

  isNativelyClearable () {
    return true;
  }

  getShortValue = () => {
    return this.getValue()?.name;
  }

  ViewComponentField = (props) => {
    const formField = this;    
    const [value, setValue] = React.useState(() => this.getValue());
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)
    const [bs4Store, setBs4Store] = React.useState(formField.bs4Store || []);
    this.refFocus = React.useRef();

    React.useEffect(() => {
      this.notValidElementDom = (text) => {
        setError({error: true, helperText: text})
      }

      const CHANGE = (field, oldValue, newValue) => {
        setValue(this.getValue());
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      };
      this.on(Bs4GenericField.CHANGE, CHANGE);
            
      const CHANGE_STORE = (bs4Store) => {
        setBs4Store(bs4Store);
        this.setValueBs4(this.getValueBs4());
      }
      this.on(Bs4GenericField.CHANGE_STORE, CHANGE_STORE);

      return () => {
        this.off(CHANGE);
        this.off(CHANGE_STORE);
      }
    }, [error, setError, setValue, setBs4Store]);

    const handleChange = (event, newValue) => {
      const newOption = bs4Store.find(option => option.id === newValue)
      this.trigger(Bs4GenericField.FOCUS_ENTER, this);
      this.setValue(newOption);
      this.trigger(Bs4GenericField.FOCUS_LEAVE, this);
    }

    const handleChangeButton = (option) => {
      this.trigger(Bs4GenericField.FOCUS_ENTER, this);
      this.setValue(option);
      this.trigger(Bs4GenericField.FOCUS_LEAVE, this);
    }

    return (
      <FormControl fullWidth  error={error.error}>
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <Box>
          <ToggleButtonGroup 
            ref={this.refFocus}
            value={value?.id || ''} 
            orientation='horizontal'
            exclusive 
            // onChange={handleChange} 
            variant='contained' 
            sx={{flexWrap: 'wrap'}}
          >
            {bs4Store.map(option => { 
              if (!('bs4style' in option)) option.bs4Style = getBs4Style(option?.style);
              return (
                <ToggleButton 
                  key={option?.id} 
                  value={option?.id}
                  onClick={() => handleChangeButton(option)}
                  sx={{                   
                    '&:hover': {
                      ...option.bs4Style,
                      '&.Mui-selected': {
                        ...option.bs4Style,
                      }
                    },
                    '&.Mui-selected': {
                      ...option.bs4Style,
                    }
                  }}
                >
                  <Bs4Tooltip arrow title={
                    <React.Fragment>
                      <Typography variant='body1' sx={{whiteSpace: 'pre-line'}}>{option.name}</Typography>
                      <Typography variant='body2' sx={{whiteSpace: 'pre-line'}}>{option.text}</Typography>          
                    </React.Fragment>
                  }>
                    {option.icon ? 
                      <Box className={option.icon}/>
                    : 
                      <Typography variant='body1'>{option.name}</Typography>
                    }
                    
                  </Bs4Tooltip>
                </ToggleButton>
              )})}
          </ToggleButtonGroup>
        </Box>
        <FormHelperText>{error.helperText}</FormHelperText>
      </FormControl>
    );
  }
}